module.exports = __webpack_public_path__ + "static/img/far4.9c424317.png";